import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth'
import { auth } from 'services/firebase'
import { FirebaseError } from '@firebase/util'
import { useNavigate } from 'react-router-dom'
import { Button, Center, Divider, Flex, Stack, Text, useToast } from '@chakra-ui/react'
import { FcGoogle } from 'react-icons/fc'
import styled from '@emotion/styled'

type Props = {
  pageType: 'login' | 'signup'
}

export const ProviderSection = ({ pageType }: Props) => {
  const navigate = useNavigate()
  const toast = useToast()
  const googleProvider = new GoogleAuthProvider()

  const signInWithGoogle = async () => {
    try {
      await signInWithPopup(auth, googleProvider)
      toast({
        title: 'Logged in successfully',
        status: 'success',
        isClosable: true,
      })
      navigate('/')
    } catch (error) {
      if (error instanceof FirebaseError) {
        toast({
          title: 'Error while logging in with Google',
          description: error.message,
          status: 'error',
          isClosable: true,
        })
      }
    }
  }
  return (
    <Container>
      <Stack spacing={4}>
        <Flex align='center'>
          <Divider />
          <Text padding='2'>or</Text>
          <Divider />
        </Flex>

        <Button width='100%' variant={'outline'} leftIcon={<FcGoogle />} onClick={signInWithGoogle}>
          <Center>
            <Text>{`Sign ${pageType === 'login' ? 'in' : 'up'} with Google`}</Text>
          </Center>
        </Button>
      </Stack>
    </Container>
  )
}

const Container = styled.div`
  margin-top: 1.25rem;
`
